import React from 'react';
import { Container } from '../style';
import "./call.css"
import { useTranslation } from 'react-i18next';


const CallCenter = () => {
    const { t } = useTranslation();

    return (
        <Container>
            <br/>
            <br/>
            <br/>
            <main className="container">
      <div className="support-options">
        <div className="support-card support-card--active">
          <svg className="support-card__icon" viewBox="0 0 24 24">
            <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H6L4 18V4H20V16Z" />
          </svg>
          <h2 className="support-card__title">{t('supportOptions.textSupport')}</h2>
          <p className="support-card__description">{t('supportOptions.textSupportDesc')}</p>
        </div>

        <div className="support-card">
          <svg className="support-card__icon" viewBox="0 0 24 24">
            <path d="M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z" />
          </svg>
          <h2 className="support-card__title">{t('supportOptions.audioSupport')}</h2>
          <p className="support-card__description">{t('supportOptions.audioSupportDesc')}</p>
        </div>

        <div className="support-card">
          <svg className="support-card__icon" viewBox="0 0 24 24">
            <path d="M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z" />
          </svg>
          <h2 className="support-card__title">{t('supportOptions.videoSupport')}</h2>
          <p className="support-card__description">{t('supportOptions.videoSupportDesc')}</p>
        </div>
      </div>

      <form className="request-form">
        <h2 className="request-form__title">{t('form.title')}</h2>

        <div className="form-group">
          <label className="form-group__label">{t('form.name')}</label>
          <input type="text" className="form-group__input" placeholder={t('form.namePlaceholder')} />
        </div>

        <div className="form-group">
          <label className="form-group__label">{t('form.email')}</label>
          <input type="email" className="form-group__input" placeholder={t('form.emailPlaceholder')} />
        </div>

        <div className="form-group">
          <label className="form-group__label">{t('form.subject')}</label>
          <input type="text" className="form-group__input" placeholder={t('form.subjectPlaceholder')} />
        </div>

        <div className="form-group">
          <label className="form-group__label">{t('form.description')}</label>
          <textarea className="form-group__textarea" placeholder={t('form.descriptionPlaceholder')}></textarea>
        </div>

        <div className="media-upload">
          <svg className="media-upload__icon" viewBox="0 0 24 24">
            <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04M19 18H6C3.79 18 2 16.21 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.08 7.14 9.94 6 12 6C14.62 6 16.88 7.86 17.39 10.43L17.69 11.93L19.22 12.04C20.78 12.14 22 13.45 22 15C22 16.65 20.65 18 19 18M8 13H10.55V16H13.45V13H16L12 9L8 13Z" />
          </svg>
          <p className="media-upload__text">{t('form.upload')}</p>
          <button type="button" className="media-upload__button">{t('form.uploadButton')}</button>
        </div>

        <div className="media-controls">
          <div className="media-control">
            <button type="button" className="media-control__button">{t('form.recordAudio')}</button>
          </div>
          <div className="media-control">
            <button type="button" className="media-control__button">{t('form.recordVideo')}</button>
          </div>
        </div>

        <button type="submit" className="submit-button">{t('form.submitButton')}</button>
      </form>
    </main>
            <br/>
            <br/>
            <br/>
        </Container>
    );
}

export default CallCenter;
